import type { SliceRouteContract } from '@/shared/lib/vsa';
import { ColumbusSlicePage } from './ColumbusSlicePage';

export const columbusRouteContract: SliceRouteContract = {
  routeId: 'columbus-planner',
  component: ColumbusSlicePage,
};
